import React from "react";
import { Container } from "reactstrap";
import JobFilters from "./JobFilters";
import StockGridDetails from "./StockGridDetails";
import Section from "./Section";
import Pagination from "../../Jobs/JobList2/Pagination";
import { Link } from "react-router-dom";
import { Weight } from "lucide-react";

const StockGrid = () => {
  document.title = "Home | StarMarket";
  return (
    <React.Fragment>
      <section className="bg-light gaps">
        <Container fluid>
          <div className="section-title pb-2">
            <span className="subtitle" style={{ fontWeight: "600" }}>
              Fresh Stocks
            </span>
            <div className="pt-2 view-more-div">
              <Link
                to="/stocks"
                className="btn submit-btn h-100"
                style={{
                  borderRadius: "50px",
                  color: "#003B8F",
                  border: "none",
                }}
              >
                View More <i className="uil uil-arrow-right"></i>
              </Link>
            </div>

            <p className="text-muted mb-1"></p>
          </div>
          <StockGridDetails />
        </Container>
      </section>
    </React.Fragment>
  );
};

export default StockGrid;
